/**
 * Replaces [singularPlural singular="singular_word" plural="plural_word"] shortcodes 
 * with the appropriate form based on count
 *
 * @param props - Function parameters
 * @param props.context - Shortcode context containing text
 * @param props.count - Number to determine singular/plural form
 *
 * @returns Updated context with replaced shortcodes
 *
 * @example
 * ```ts
 * applySingularPlural({
 *   context: { text: '[singularPlural singular="user" plural="users"]', locale: "en" },
 *   count: 1
 * });
 * // Result: 'user'
 * 
 * applySingularPlural({
 *   context: { text: '[singularPlural singular="user" plural="users"]', locale: "en" },
 *   count: 2
 * });
 * // Result: 'users'
 * ```
 */
import { ShortcodeContext } from '..';

export const applySingularPlural = ({
  context,
  count,
}: {
  context: ShortcodeContext;
  count: number;
}): ShortcodeContext => {
  // New regex pattern to match [singularPlural singular="word1" plural="word2"]
  const regex = /\[singularPlural\s+singular="([^"]+)"\s+plural="([^"]+)"\]/g;
  
  context.text = context.text.replace(
    regex,
    (_, singular, plural) => count <= 1 ? singular : plural
  );
  
  return context;
};
